import './Problem.css';

export default function Problem() {
  return (
    <section id="problem" className="problem section">
      <div className="container">
        <h2>
          We Live in an Age
          <br /> of Moving Images
        </h2>
        <div className="problem-content">
          <p className="problem-lead">
            - First steps on your <span className="problem-highlight">phone.</span> <br />- Birthday
            candles on the <span className="problem-highlight">iPad.</span> <br />- School concerts on
            the <span className="problem-highlight">camera.</span>
          </p>
          <p>
            Many separate files. Stored somewhere...
            <br />
            <br />
            But when was the last time you actually watched them?
            <br />
            <br />
            Hard drives get tucked away. Cloud storage becomes a digital junk drawer.
            <br />
            <br />
            Those irreplaceable moments just sit there, unseen.
            <br />
            <br />
            Until they're forgotten.
            <br />
            <br />
            Or worse, lost.
          </p>
          <p className="problem-solution">
            At Kids Vids we provide an Editing service that brings those clips back to life.
          </p>

          <div className="scroll-arrow">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7 10L12 15L17 10"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7 10L12 15L17 10"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7 10L12 15L17 10"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div className="scroll-arrow">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7 10L12 15L17 10"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7 10L12 15L17 10"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div className="scroll-arrow">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7 10L12 15L17 10"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>
      </div>
    </section>
  );
}
